import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Category slugs rendered with their human label when the categories query has loaded, and
 * with the slug itself otherwise, so a card never waits on a second request to be readable.
 */
export function CategoryBadges({
  slugs,
  labels,
  max = 3,
  className,
}: {
  slugs: string[];
  labels?: Map<string, string>;
  max?: number;
  className?: string;
}) {
  if (slugs.length === 0) return null;
  const shown = slugs.slice(0, max);
  const overflow = slugs.length - shown.length;

  return (
    <ul className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {shown.map((slug) => (
        <li key={slug}>
          <Badge variant="secondary">{labels?.get(slug) ?? slug}</Badge>
        </li>
      ))}
      {overflow > 0 ? (
        <li>
          <Badge variant="outline" title={slugs.slice(max).join(', ')}>
            +{overflow}
          </Badge>
        </li>
      ) : null}
    </ul>
  );
}
